import { Overview as OverviewComponent } from 'modules/trainings/components/TrainingDetail/Overview'

const Overview = () => {
  return <OverviewComponent />
}

export default Overview
